import { Component } from '@angular/core';
import { NavigationService } from './core/service/navigation.service';
import { TabService } from './core/service/tab.service';
import { UpdateService } from './core/service/update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ae-employment-admin';
  constructor(  private tabService: TabService, public navigation: NavigationService, private sw: UpdateService){
    this.navigation.startSaveHistory();
  }
}
